/**
 * TKP-64 / tasarım s.3 Öneri 2 md.3–4 — "süreç eklenebilir" işareti. Alan yoksa (işaretten önceki kayıt) eklenebilir;
 * backend `isProcessAllowed` ile aynı kural. Varlıklar birim listesi bu sorguyla süzülür.
 */
export const isProcessAllowed = (department) => !!department && department.processAllowed !== false;

export const processAllowedQuery = () => ({ processAllowed: { value: { $ne: false }, isObject: true } });
